import React, { useState, useEffect, useRef, useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";

import { Layout, Row, Col, notification, Modal, Tooltip, Typography } from "antd";
import Spin from "Components/Spinner";
import Banner from "../Components/Banner";
import LanguageSelector from "../Components/Shared/LanguageSelector";
import MainContent from "../Components/MainContent";
import SideBar from "../Components/SideBar";
import apiClient from "utils/apiHandler";
import { useParams, useSearchParams } from "react-router-dom";
import { analytics_create_event_post } from "../api/analytics";
import { action_pre_checkout_post, action_pre_checkout_option_post } from "../api/actions";
import ErrorGettingProduct from "../Components/Shared/ErrorGettingProduct";
import ProductNotFound from "../Components/Shared/ProductNotFound";
import ProductOfferNotFound from "../Components/Shared/ProductOfferNotFoundV2";
import ProductUnavailable from "../Components/Shared/ProductUnavailable";
import ProductSalesClosed from "../Components/Shared/ProductSalesClosed";
import AccountSuspended from "../Components/Shared/AccountSuspended";
import AccountClosed from "../Components/Shared/AccountClosed";
import OrderDuplicated from "../Components/Shared/OrderDuplicated";
import ProductEventIsFull from "../Components/Shared/ProductEventIsFull";
import { CodeOutlined, UserSwitchOutlined } from "@ant-design/icons";
import {
  saveOnLocalStorage,
  IsNullUndefinedEmpty,
  NotNullUndefinedEmpty,
  loadLocalData,
  store,
  createPurchaseProductsList,
  isIntegerNumber,
  saveAffiliateId,
  paymentMethodsArray,
} from "../utils/helper";
import { getPurchaseId, isProductValid, getProduct } from "../utils/api";
import backupCountries from "../config/countries.json";
import { countries_fiscal_get } from "../api/actions";
import { product_metrics_post } from "../api/products";
import DebugConsoleDrawer from "../Components/DebugConsoleDrawer";
import { dummyData } from "Components/DebugConsoleDrawer/helper";
//import ReactPixel from "react-facebook-pixel";
import { pixelEventPageView, pixelEventInitiateCheckout, pixelEventAddPaymentInfo } from "../utils/pixels";

import { loadFromLocalStorage, validateAllowedCountry, parsePAA, getOrCreateClientId } from "../utils/helper";

import moment from "moment-timezone";
import { Helmet } from "react-helmet";
import { utmParams, appendParamsToUrl } from "utils/helper";
import { isNil, isNilOrEmpty } from "@salespark/toolkit";
import { CHECKOUT_DEFAULT_STYLES, resolveCheckoutTheme } from "utils/checkoutTheme";

const { Header, Content } = Layout;
const { Text } = Typography;

const isWidget = window?.location?.hash?.substr(1) === "widget";
const env = process.env.REACT_APP_ENVIRONMENT?.toLowerCase();
const IndexPage = (props) => {
  const { t } = useTranslation();
  let { product_id } = useParams();
  const PRODUCT_ID = product_id || "";
  const [searchParams, setSearchParams] = useSearchParams();
  //console.log("ENVIRONMENT", env, "isWidget", isWidget);
  //const search = window.location.search;
  // const params = new URLSearchParams(search);
  const OFFERS = searchParams.get("offer");
  const LEGACY_PRODUCT_ID = searchParams.get("p") || "";

  const _NAME = searchParams.get("name") || "";
  const _EMAIL = searchParams.get("email") || "";
  const _PHONE = searchParams.get("phone") || "";
  const _VATID = searchParams.get("vatid") || "";
  let _COUPON = searchParams.get("coupon") || "";
  const _IS_OFFER = searchParams.get("gift") || "";
  const _QTY = searchParams.get("qty") || 1;
  const _HIDE_METHOD = searchParams.get("hide_method") || null;
  const _STEP = searchParams.get("step") || "";
  const _SOURCE = searchParams.get("source") || "checkout";
  const _AFFILIATE_ID = parsePAA(searchParams.get("aff") || searchParams.get("paa") || "");

  const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } = utmParams();

  const [isLoading, setIsLoading] = useState(true);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [errorType, setErrorType] = useState(null);
  const [errorTypeMessage, setErrorTypeMessage] = useState(null);
  const [step, setStep] = useState(0);
  // DEV: bumping this remounts <Identification /> so it re-reads the values written to state
  const [identificationKey, setIdentificationKey] = useState(0);
  const [productData, setProductData] = useState(null);
  const [duplicatesSales, setDuplicatesSales] = useState(0);
  const [state, setState] = useState({ status: { action: "identification", data: {} } });
  const [debugConsole, setDebugConsole] = useState({ visible: false, data: null });
  const [purchaseId, setPurchaseId] = useState(null);

  const [identification, setIdentification] = useState({
    name: _NAME,
    email: _EMAIL,
    phone: _PHONE,
    vatid: _VATID,
  });

  const [countries, setCountries] = useState([]);
  const pingIntervalRef = useRef(null);

  const customization = productData?.advanced?.customization;
  const checkoutThemeKey = JSON.stringify(customization?.checkout_styles ?? null);

  const checkoutStyles = useMemo(
    () => resolveCheckoutTheme(customization, CHECKOUT_DEFAULT_STYLES),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [checkoutThemeKey],
  );

  useEffect(() => {
    //console.log("IndexPage", LEGACY_PRODUCT_ID, PRODUCT_ID);

    // Check if blocked buyer
    // if (store("GET", "blocked-buyer") === "1") {
    //   window.location.href = "/something-went-wrong";
    //   return;
    // }

    if (!IsNullUndefinedEmpty(LEGACY_PRODUCT_ID) && IsNullUndefinedEmpty(PRODUCT_ID)) {
      window.location.href = `/${LEGACY_PRODUCT_ID}`;
      return;
    } else if (IsNullUndefinedEmpty(LEGACY_PRODUCT_ID) && IsNullUndefinedEmpty(PRODUCT_ID)) {
      // No product in URL: redirect to the marketplace, carrying the UTM data
      const marketplaceUrl = process.env.REACT_APP_MARKETPLACE_URL || "http://localhost:4002";
      window.location.href = appendParamsToUrl(marketplaceUrl, {
        utm_source,
        utm_medium,
        utm_campaign,
        utm_term,
        utm_content,
      });
      return;
    } else {
      InitCheckout(PRODUCT_ID);
    }
  }, []);

  useEffect(() => {
    pingIntervalRef.current = setInterval(() => {
      ping();
    }, 60000); // Every 60 seconds

    return () => {
      if (pingIntervalRef.current) {
        clearInterval(pingIntervalRef.current);
      }
    };
  }, []);

  const ping = async (purchase_id) => {
    try {
      if (isNil(purchaseId) && isNil(purchase_id)) return;
      const utm = { utm_source, utm_medium, utm_campaign, utm_term, utm_content };
      const clientId = getOrCreateClientId();
      const payload = { product_id: PRODUCT_ID, step: step, purchase_id: purchase_id || purchaseId, client_id: clientId, utm: utm };

      await apiClient.post("/actions/checkout/ping", payload);

      // Error handling
    } catch (error) {
      // Ignore
    }
  };

  const updateProductMetrics = async (productId) => {
    try {
      const payload = {
        action: "view",
        origin: "checkout",
        product_id: productId,
        viewer: {
          type: "buyer",
        },
      };
      await dbUpdateProductMetricsPost(productId, payload);

      // Error handling
    } catch (error) {
      // console.log("updateProductMetrics", error);
    }
  };

  const dbUpdateProductMetricsPost = (product_id, payload) => {
    return new Promise((resolve) => {
      try {
        product_metrics_post(product_id, payload)
          .then((res) => resolve({ status: true, data: res.data }))
          .catch((err) => resolve({ status: false, data: err }));

        // Error handling
      } catch (error) {
        resolve({ status: false, data: error });
      }
    });
  };

  const AddToAnalytics = (event, payload) => {
    // TODO: Missing error log
    try {
      analytics_create_event_post(event, payload)
        .then((res) => {})
        .catch((err) => {});
    } catch (error) {}
  };

  const dbGetCountriesFiscal = async () => {
    return new Promise((resolve) => {
      try {
        countries_fiscal_get()
          .then((res) => resolve({ status: true, data: res.data, version: res?.headers?.["x-countries-fiscal-version"] }))
          .catch((err) => resolve({ status: false, data: err }));
      } catch (error) {
        resolve({ status: false, data: error });
      }
    });
  };

  const geolocationResponse = (timeout = 4000) => {
    return new Promise(async (resolve) => {
      try {
        const countries_response = await dbGetCountriesFiscal();
        const _countries = countries_response.status ? countries_response.data : backupCountries;

        // Resolve country from the buyer IP via our backend (MaxMind GeoLite2). 4s timeout, no retry -> PT fallback.
        // apiClient never throws: it returns { status, data: <backend body> }. On failure -> PT fallback.
        const res = await apiClient.get("/geo", { timeout, retry: 0 });
        if (!res?.status) {
          resolve({ status: true, data: getFallbackGeoLocation(), isFallback: true });
          return;
        }

        const geoData = res.data;
        const detected = geoData?.country; // ISO2 (supported fiscal country, else PT from backend)
        const regionName = geoData?.region_name; // EN subdivision name (matches PT Açores/Madeira by state)

        let _country = _countries.find((c) => c.value === detected) || _countries.find((c) => c.value === "PT");
        let _region = _country?.regions?.find((c) => c.state === regionName) || _country?.regions?.[0];

        resolve({ status: true, data: { countries: _countries, country: _country, region: _region } });
      } catch (error) {
        const r = getFallbackGeoLocation();
        resolve({ status: true, data: r, isFallback: true });
      }
    });
  };

  const getFallbackGeoLocation = () => {
    const _countries = backupCountries;
    const _country = _countries.find((c) => c.value === "PT");
    // setSelectedCountry(_country);
    // setSelectedRegion(_country.regions[0]);
    return { countries: _countries, country: _country, region: _country.regions[0] };
  };

  const setDuplicatesCounter = (count) => {
    if (!count) count = 0;

    setDuplicatesSales(count);
  };
  const checkDuplicated = async (payload) => {
    try {
      if (!payload) return;

      setDuplicatesCounter(0);

      const response = await apiClient.post("/actions/check-duplicated", payload);
      if (!response.status) {
        setDuplicatesCounter(0);
        return;
      }

      setDuplicatesCounter(response.data.count || 0);

      // Error handling
    } catch (error) {
      setDuplicatesCounter(0);
    }
  };

  const parseCheckEmailError = (data) => {
    //Invalid email
    if (data.code === 100) {
      return {
        message: <Trans i18nKey="checkout.emailInvalidWithEmail" values={{ email: data.email }} components={{ bold: <strong /> }} />,
      };
    }

    //Invalid domain
    if (data.code === 110) {
      return {
        message: <Trans i18nKey="checkout.emailDomainInvalidWithEmail" values={{ email: data.email }} components={{ bold: <strong /> }} />,
      };
    }

    //Rejected/Email may not exists"
    if (data.code === 120) {
      return {
        message: <Trans i18nKey="checkout.emailUncertainWithEmail" values={{ email: data.email }} components={{ bold: <strong /> }} />,
      };
    }

    // Other cases
    return {
      message: <Trans i18nKey="checkout.emailInvalidWithEmail" values={{ email: data.email }} components={{ bold: <strong /> }} />,
    };
  };

  const checkEmail = async (payload) => {
    try {
      const response = await apiClient.post("/actions/check-email-v2", payload);
      if (!response.status) {
        return { show_notification: false, data: response.data };
      }

      const data = response.data;
      if (data.status === false && data.code >= 100 && data.code < 500) {
        return { show_notification: true, data: parseCheckEmailError(data) };
      }

      return { show_notification: false, data: data };

      // Error handling
    } catch (error) {
      return { show_notification: false, data: error };
    }
  };

  const addPreCheckoutOptionEvent = (data) => {
    try {
      const payload = {
        affiliate_id: data.affiliate_id,
        purchase_id: data.purchase_id,
        identification: data.identification,
        payment_method: data.payment_method,
        purchase_products: data.purchase_products,
        price_option: data.price_option,
        product_id: data.main_product,
        coupon: data.coupon,
        order_bumps: data.bumps,
        geo: {
          country: data.geo?.country?.value,
          region: data.geo?.region?.value,
        },
      };
      action_pre_checkout_option_post(payload)
        .then((res) => {
          // console.log("PreCheckoutOptions", res.data);
        })
        .catch((err) => {
          //
        });

      // Error handling
    } catch (error) {
      // Error handling
    }
  };

  const addPreCheckoutEvent = async (payload) => {
    // TODO: Missing error log
    if (payload?.format !== "one-time-service") {
      const precheckout = store("GET", `precheckout-${payload.purchase_id}`, "BOOL");
      if (precheckout) return;
    }

    try {
      const preCheckoutResponse = await apiClient.post("/actions/pre-checkout", payload);
      if (!preCheckoutResponse.status) {
        if (payload?.format === "one-time-service") {
          Modal.error({
            title: t("checkout.oops"),
            content: t("checkout.orderErrorContent"),
          });
          actionHandler("move", 0);
          return;
        }
      }

      const precheckout = preCheckoutResponse.data;
      store("SET", `precheckout-${payload.purchase_id}`, "1");

      if (precheckout?.status === "blocked") {
        // store("SET", "blocked-buyer", "1");
        window.location.href = "/something-went-wrong?t=0001";
        return;
      }

      if (precheckout?.status === "blocked-by-producer") {
        window.location.href = "/something-went-wrong?t=0002";
        return;
      }

      // action_pre_checkout_post(payload)
      //   .then((res) => {
      //     store("SET", `precheckout-${payload.purchase_id}`, "1");

      //     if (res?.data?.status === "blocked") {
      //       // store("SET", "blocked-buyer", "1");
      //       window.location.href = "/something-went-wrong?t=0001";
      //       return;
      //     }

      //     if (res?.data?.status === "blocked-by-producer") {
      //       window.location.href = "/something-went-wrong?t=0002";
      //       return;
      //     }
      //   })
      //   .catch((err) => {});

      // Error handling
    } catch (error) {}
  };

  const retryGeoLocation = async (allowed_countries) => {
    try {
      const geo = await geolocationResponse(15000);

      const selCountry = geo.data.country;

      const allowedCountry = validateAllowedCountry(allowed_countries, selCountry?.value);

      if (!allowedCountry) {
        window.location.href = "/invalid-country";
        return;
      }

      // Error handling
    } catch (error) {
      // Ignore
    }
  };

  const InitCheckout = async (product_id, isUpdate = false, _state = undefined) => {
    //console.log("InitCheckout");
    setIsLoading(true);
    try {
      if (_state === undefined || _state === null) _state = state;

      // Prevent multiple calls
      if (isUpdate === false) {
        if (NotNullUndefinedEmpty(productData) || IsNullUndefinedEmpty(product_id)) {
          setIsLoading(false);
          return;
        }
      }

      store("SET", "checks", "0");
      store("SET", "original_url", window.location.href);

      // Start geolocation in parallel with is-valid (no added latency; resolved below)
      const geoPromise = !isUpdate ? geolocationResponse() : null;

      // Persistent per-browser client id (survives refresh) so the API dedups live checkouts across refresh / re-mint.
      const clientId = getOrCreateClientId();

      // Check if product is valid
      const productIsValidResponse = await isProductValid(product_id, clientId);
      if (productIsValidResponse.status === false || isNilOrEmpty(productIsValidResponse.data)) {
        InitFailed(false, t("checkout.productDataError"));
        setIsLoading(false);
        return;
      }

      // Sales are closed
      if (productIsValidResponse.data.code === 3030) {
        salesClosed(productIsValidResponse.data);
        setIsLoading(false);
        return;
      }

      let selCountry;
      let selRegion;
      let countries;
      let isGeoFallback = false;
      if (!isUpdate) {
        const geo = await geoPromise;

        if (geo.isFallback) {
          isGeoFallback = true;
        }
        selCountry = geo.data.country;
        selRegion = geo.data.region;
        countries = geo.data.countries;
      } else {
        selCountry = _state.geo.country;
        selRegion = _state.geo.region;
        countries = _state.countries;
      }

      setCountries(countries);

      // Get Purchase Id
      let purchaseId = productIsValidResponse.data.purchase_id;
      if (purchaseId === undefined || purchaseId === null) {
        const purchase_id_response = await getPurchaseId(product_id);
        if (!purchase_id_response.status) {
          InitFailed(false, t("checkout.purchaseIdError"));
          setErrorType("purchase_id_not_found");
          setIsLoading(false);
          return;
        } else {
          purchaseId = purchase_id_response.data;
        }
      }

      setPurchaseId(purchaseId);
      ping(purchaseId); // Initial ping

      _state = { ..._state, affiliate_id: _AFFILIATE_ID };

      store("SET", "purchase_id", purchaseId);

      // Check if product is in Sandbox mode
      if (productIsValidResponse.data.code === 7001 && productIsValidResponse.data.sandbox === true) {
        activateSandbox(productIsValidResponse.data);
      }

      // Producer not allowed to sell
      if (productIsValidResponse.data.code === 4004 || productIsValidResponse.data.code === 9041) {
        accountSuspended(productIsValidResponse.data);
        setIsLoading(false);
        return;
      }

      // if (product_is_valid_response.data.code === 9041) {
      //   accountSuspended(product_is_valid_response.data);
      //   setIsLoading(false);
      //   return;
      // }
      if (productIsValidResponse.data.code === 9042 || productIsValidResponse.data.code === 9043) {
        accountClosed(productIsValidResponse.data);
        setIsLoading(false);
        return;
      }

      if (productIsValidResponse.data.code === 5309) {
        productSalesClosed(productIsValidResponse.data);
        setIsLoading(false);
        return;
      }

      if (
        productIsValidResponse.data.code === 5850 || //Product status: Rascunho
        productIsValidResponse.data.code === 5860 || //Product status: Em revisão
        productIsValidResponse.data.code === 5870 || //Product status: Ajustes pendentes
        productIsValidResponse.data.code === 5880 || //Product status: Vendas Encerradas
        productIsValidResponse.data.code === 5890 || //Product status: Reprovado
        productIsValidResponse.data.code === 7801 || //Course is not Ready
        productIsValidResponse.data.code === 7902 || //Error loading bundle products
        productIsValidResponse.data.code === 7903 || //Bundle has invalid products
        productIsValidResponse.data.valid === false
      ) {
        productUnavailable(productIsValidResponse.data);
        setIsLoading(false);
        return;
      }

      const productResponse = await getProduct(PRODUCT_ID, OFFERS, selCountry.value, selRegion.value, {
        coupon_code: _state.coupon?.coupon_code,
        identification: _state.identification,
        main_product: _state.main_product,
        price_options: _state.price_options,
        purchase_id: purchaseId,
        purchase_products: _state.purchase_products,
        price_option: _state.price_option,
        qty: _state.qty,
        affiliate_id: _state.affiliate_id,
      });

      //console.error("Error loading product", productResponse);
      if (productResponse.status === false && productResponse?.data?.response?.data?.code === 404) {
        const errorCode = productResponse?.data?.response?.data?.error_code;

        //   998002 - Order with same purchase_id already exists.
        if (errorCode === 998002) {
          orderDuplicated(productResponse?.data?.response?.data);
          setIsLoading(false);
          return;
        }

        if (errorCode === 990012) {
          productOfferNotFound(productResponse?.data?.response?.data);
          setIsLoading(false);
          return;
        }

        if (errorCode === 990013) {
          productEventIsFull();
          setIsLoading(false);
          return;
        }

        productNotFound(productResponse?.data?.response?.data);
        setIsLoading(false);
        return;
      } //

      let maxQtyAllowed = 99999;
      let maxQtyPerPurchase = 99999;
      //max_purchase_amount
      let maxPurchaseAmount = 10000; // 10.000,00 EUR

      if (productResponse.data?.max_purchase_amount) {
        maxPurchaseAmount = productResponse.data.max_purchase_amount;
      }

      // Check if product is online event
      if (productResponse.data.format === "online-event") {
        const eventData = productResponse.data.extra.online_event;
        maxQtyAllowed = eventData.max_capacity || 99999;
        maxQtyPerPurchase = eventData.max_tickets_per_purchase || 99999;

        // Check if eventData end_date is after now
        if (moment(eventData.end_date).isBefore(moment())) {
          productSalesClosed({
            message: t("checkout.eventEndedMessage", { name: productResponse.data.information.name }),
          });
          setIsLoading(false);
          return;
        }
      }

      // Check if product is online event
      if (productResponse.data.format === "physical-event") {
        const eventData = productResponse.data.extra.physical_event;
        maxQtyAllowed = eventData.max_capacity || 99999;
        maxQtyPerPurchase = eventData.max_tickets_per_purchase || 99999;

        // Check if eventData end_date is after now
        if (moment(eventData.end_date).isBefore(moment())) {
          productSalesClosed({
            message: t("checkout.eventEndedMessage", { name: productResponse.data.information.name }),
          });
          setIsLoading(false);
          return;
        }
      }

      // Check if product is digital-quantity (max per purchase only, no stock)
      if (productResponse.data.format === "digital-quantity") {
        const dqData = productResponse.data.extra?.digital_quantity || {};
        maxQtyAllowed = dqData.max_capacity || 99999;
        maxQtyPerPurchase = dqData.max_qty_per_purchase || 99999;
      }

      const product = productResponse.data;

      if (isGeoFallback === true) {
        retryGeoLocation(product.allowed_countries);
      }

      if (isGeoFallback === false) {
        const allowedCountry = validateAllowedCountry(product.allowed_countries, selCountry?.value);
        if (!allowedCountry) {
          window.location.href = "/invalid-country";
          return;
        }
      }

      setProductData(product);

      const isEvent = product.format === "online-event" || product.format === "physical-event";

      const defaultPriceOption = product.offers[0];

      saveAffiliateId(_AFFILIATE_ID, product_id, _state, product?.affilition);

      let ls = loadLocalData(_state, product);

      if (isNilOrEmpty(identification.name) === false) {
        ls = {
          ...ls,
          identification: {
            ...ls.identification,
            name: identification.name,
          },
        };
      }

      if (isNilOrEmpty(identification.email) === false) {
        ls = {
          ...ls,
          identification: {
            ...ls.identification,
            email: identification.email,
          },
        };
      }

      if (IsNullUndefinedEmpty(identification.phone) === false) {
        ls = {
          ...ls,
          identification: {
            ...ls.identification,
            phone: identification.phone,
          },
        };
      }

      if (IsNullUndefinedEmpty(identification.vatid) === false) {
        ls = {
          ...ls,
          identification: {
            ...ls.identification,
            vatid: identification.vatid,
          },
        };
      }

      //let _state = state;
      if (ls !== null) _state = ls;
      _state = { ..._state, price_option: defaultPriceOption, format: product.format };

      if (_COUPON !== "" && _COUPON !== undefined && _COUPON !== null) {
        _state = { ..._state, trigger_coupon: true, temp_coupon: _COUPON };
      } else {
        delete _state.trigger_coupon;
        delete _state.temp_coupon;
      }
      if (_state?.qty === undefined) {
        if (isIntegerNumber(_QTY) === true && (isEvent === true || product.format === "digital-quantity")) {
          _state = { ..._state, qty: parseInt(_QTY) };
        } else {
          _state = { ..._state, qty: 1 };
        }
      }

      const purchaseProducts = createPurchaseProductsList(product, _state);
      _state = { ..._state, purchase_products: purchaseProducts, purchase_id: purchaseId };

      _state = { ..._state, coupon: product.coupon };
      if (product.coupon) {
        if (product?.coupon?.valid === true) {
          notification.success({
            message: t("checkout.couponAppliedMessage"),
            description: t("checkout.couponAppliedDescription"),
          });
        }
        if (product?.coupon?.valid === false) {
          _state = { ..._state, temp_coupon: undefined, trigger_coupon: false };
          Modal.warning({
            title: t("checkout.oops"),
            content: t(product?.coupon?.message, { code: product?.coupon?.code }),
          });
        }
      }

      let _payment_methods = product.advanced?.payment_methods;

      if (_payment_methods === undefined || _payment_methods === null || _payment_methods?.length === 0) {
        _payment_methods = ["creditcard", "mb", "mbway", "paypal"];
      }
      const _thankyou_page = product.advanced?.thankyou_page;

      _state = {
        ..._state,
        producer: product.producer,
        main_product: PRODUCT_ID,
        is_offer: ["true", "sim", "1"].includes(_IS_OFFER?.toLowerCase()) ? true : false,
        geo: { country: selCountry, region: selRegion },
        countries: countries,
        allowed_methods: _payment_methods,
        ask_vatid_on_checkout: product.advanced?.ask_vatid_on_checkout,
        thankyou_page: _thankyou_page,
        meta_pixel: product?.meta_pixel,
        ga4_pixel: product?.ga4_pixel,
        gtm_pixel: product?.gtm_pixel,
        producer_terms: product.advanced.producer_terms,
        allow_coupons: product.advanced.allow_coupons,
        customization: product.advanced?.customization,
        free_resolution_waiver_enabled: product.advanced?.free_resolution_waiver_enabled,
        free_resolution_waiver_mandatory: product.advanced?.free_resolution_waiver_mandatory,
        allow_offer: product.advanced?.allow_offer,
        is_teaser: product.is_teaser,
        required_checkout_billing: product.required_checkout_billing || false,
        required_checkout_vat_id: product.required_checkout_vat_id || false,
        required_checkout_complete_billing: product.required_checkout_complete_billing || false,
      };

      if (_state.payment_method === undefined || _state.payment_method === null) {
        _state = { ..._state, payment_method: { method_id: "mbway", name: "MB WAY" } };
      }

      if (IsNullUndefinedEmpty(_HIDE_METHOD) === false) {
        const hiddenMethods = _HIDE_METHOD.split(",")?.map((item) => item?.toLowerCase()?.trim());
        if (hiddenMethods.length > 0) {
          _state = { ..._state, hide_method: hiddenMethods };
        }
      }

      const mainProduct = _state?.purchase_products?.find((p) => p.type === "main");

      if (mainProduct?.price_method !== "one_time" && ["paypal", "klarna"].includes(_state.payment_method?.method_id)) {
        _state = { ..._state, payment_method: { method_id: "mbway", name: "MB WAY" } };
      }

      //****************************************************************************************** */
      //****************************************************************************************** */
      try {
        const filteredPaymentMethods = paymentMethodsArray(t).filter(
          (method) => _state?.allowed_methods?.includes(method.method_id) && !_state?.hide_method?.includes(method.method_id),
        );
        // Check if the selected payment method is in the filtered list, if not, set it to the first one
        if (filteredPaymentMethods.map((el) => el.method_id)?.includes(_state.payment_method?.method_id) === false) {
          const firstMethod = filteredPaymentMethods[0];
          if (firstMethod) {
            // console.log("firstMethod", firstMethod);
            _state = { ..._state, payment_method: { method_id: firstMethod.method_id, name: firstMethod.name } };
          }
        }
      } catch (error) {}

      //****************************************************************************************** */
      //****************************************************************************************** */
      if (IsNullUndefinedEmpty(_STEP) === false) {
        _state = { ..._state, next_step: _STEP };
      }

      // Max allowed purchase amount (total amount of the purchase)
      _state = { ..._state, max_purchase_amount: maxPurchaseAmount };

      // Max quantity allowed (online event, physical event, etc.)
      _state = { ..._state, max_qty_available: maxQtyAllowed, max_qty_per_purchase: maxQtyPerPurchase };

      _state = { ..._state, allowed_countries: product.allowed_countries };

      setState(_state);
      setIsLoading(false);
      setDataLoaded(true);

      pixelEventPageView(_state);

      updateProductMetrics(PRODUCT_ID);
      AddToAnalytics("pageview", { product_id: PRODUCT_ID, offers: OFFERS, purchase_id: purchaseId, source: _SOURCE });
    } catch (error) {
      console.error("Error in InitCheckout", error);
      setErrorType("error_loading_product");
      setDataLoaded(true);
      setIsLoading(false);
    }
  };

  // After InitCheckout without success
  const InitFailed = () => {
    setErrorType("error_loading_product");
    setDataLoaded(true);
    setIsLoading(false);
    //setErrorType("error_loading_product");
  };

  const productNotFound = (data) => {
    setErrorType("product_not_found");
    setDataLoaded(true);
    setIsLoading(false);
  };

  const productOfferNotFound = (data) => {
    setErrorType("product_offer_not_found");
    setDataLoaded(true);
    setIsLoading(false);
  };

  const productEventIsFull = (data) => {
    setErrorType("product_event_is_full");
    setDataLoaded(true);
    setIsLoading(false);
  };

  const productUnavailable = (data) => {
    setErrorType("product_unavailable");
    setDataLoaded(true);
    setIsLoading(false);
  };

  const orderDuplicated = (data) => {
    setErrorType("order_duplicated");
    setDataLoaded(true);
    setIsLoading(false);
  };

  const productSalesClosed = (data) => {
    setErrorType("sales_closed");
    if (data?.message) setErrorTypeMessage(data.message);
    setDataLoaded(true);
    setIsLoading(false);
  };

  const accountSuspended = (data) => {
    setErrorType("account_suspended");
    setDataLoaded(true);
    setIsLoading(false);
  };

  const accountClosed = (data) => {
    setErrorType("account_closed");
    setDataLoaded(true);
    setIsLoading(false);
  };

  const salesClosed = (data) => {
    //   {
    //     "valid": false,
    //     "code": 3030,
    //     "action": "https://www.youtube.com/watch?v=K7Fi7JyAlMs"
    // }

    if (data?.action?.startsWith("http")) {
      window.location.href = data.action;
    } else {
      setErrorType("sales_closed");
      setDataLoaded(true);
      setIsLoading(false);
    }
    return;
  };

  const activateSandbox = (data) => {
    // TODO: Activate sandbox, show message, get api keys for testing...
  };

  // Mints a fresh purchase_id (new order/payment will be created by the payment method components).
  // Returns the new id so callers can merge it into a single setState (avoids stale-id races).
  const regeneratePurchaseId = async () => {
    try {
      const resp = await getPurchaseId(PRODUCT_ID);
      if (!resp.status || IsNullUndefinedEmpty(resp.data)) return state.purchase_id; // fail-safe: keep current id
      const newId = resp.data;
      store("DELETE", `precheckout-${state.purchase_id}`); // housekeeping of old gate key
      setPurchaseId(newId);
      store("SET", "purchase_id", newId);
      ping(newId);
      return newId;
    } catch (e) {
      return state.purchase_id;
    }
  };

  const actionHandler = async (name, data) => {
    let _state = state;
    let reloadData = false;

    if (name === "move") {
      let _next = { ..._state };
      // Going BACK out of the payment step => mint a new purchase_id so a fresh order is created on return
      if (step === 2 && data < 2) {
        const newId = await regeneratePurchaseId();
        _next = { ..._next, purchase_id: newId };
        _next = { ..._next, purchase_products: createPurchaseProductsList(productData, _next) };
        if (data === 0) _next = { ..._next, status: { action: "checkout" } }; // avoid stale wait-for-payment
      }
      setStep(data);
      const _s = movingActionHandler(data, _next);
      setState({ ..._next, ..._s, qty_locked: false });
      return;
    }

    // ===========================================================================================
    // UPDATE IDENTIFICATION
    // ===========================================================================================
    if (name === "update-identification") {
      if (IsNullUndefinedEmpty(data.name) && IsNullUndefinedEmpty(data.email) && IsNullUndefinedEmpty(data.phone)) {
        return;
      }

      _state = { ..._state, identification: data };
      saveOnLocalStorage("identification", data);
      setState(_state);
      return;
    } // End of "update-identification"

    // ===========================================================================================
    // IDENTIFICATION
    // ===========================================================================================
    if (name === "identification") {
      _state = { ..._state, identification: data };
      delete _state.next_step;
      saveOnLocalStorage(name, data);

      if (_state?.is_teaser === true) {
        setStep(99);
      }

      if (_state?.is_teaser !== true) {
        setStep((value) => value + 1);

        AddToAnalytics("precheckout", {
          product_id: PRODUCT_ID,
          qty: _state.qty,
          offers: OFFERS,
          purchase_id: _state.purchase_id,
          source: _SOURCE,
        });

        pixelEventInitiateCheckout(_state);

        addPreCheckoutEvent({
          product_id: PRODUCT_ID,
          qty: _state.qty,
          offers: OFFERS,
          selected_offer_id: _state.price_option?.offer_id,
          purchase_id: _state.purchase_id,
          client_id: getOrCreateClientId(),
          identification: data,
          meta_pixel: _state.meta_pixel,
          ga4_pixel: _state.ga4_pixel,
          gtm_pixel: _state.gtm_pixel,
          utm_source: utm_source,
          utm_medium: utm_medium,
          utm_campaign: utm_campaign,
          utm_term: utm_term,
          utm_content: utm_content,
          affiliate_id: _state.affiliate_id,
          format: _state.format,
          // Free resolution waiver signed
          free_resolution_waiver: data.free_resolution_checkbox || false,
          is_offer: data.is_offer || false,
        });
      } // End of "Is NOT Teaser" (Normal purchase flow)

      // Check Email if customization check_email is enabled
      if (state?.customization?.check_email === true) {
        // Check if email is valid (domain, etc.)
        const checkStatus = await checkEmail({ email: data.email });

        if (checkStatus.show_notification) {
          Modal.confirm({
            title: t("checkout.emailCheckTitle"),
            content: checkStatus.data.message,
            okText: t("checkout.emailCheckOk"),
            cancelText: t("checkout.emailCheckCancel"),
            onOk() {
              // continue / do nothing
            },
            onCancel() {
              actionHandler("move", 0);
            },
          });
        }
      }
    }

    // ===========================================================================================
    // OPTIONS
    // ===========================================================================================
    if (name === "options") {
      const _step = step + 1;
      setStep(_step);
      const _s = movingActionHandler(_step, _state);
      _state = { ..._state, ..._s };
      addPreCheckoutOptionEvent(_state);
    }

    if (name === "price_option") {
      _state = { ..._state, price_option: data };
      saveOnLocalStorage(name, data, productData?.product_id);
      addPreCheckoutOptionEvent(_state);
      reloadData = true;
    }

    if (name === "qty") {
      _state = { ..._state, qty: data };

      // addPreCheckoutOptionEvent(_state);
      // reloadData = false;
    }

    if (name === "payment_method") {
      // Changing the method while already on the payment step => new purchase_id (fresh order + payment).
      // Re-selecting the same method is a no-op; first selection on the Options step never regenerates.
      let newId = _state.purchase_id;
      const methodChanged = data?.method_id !== _state.payment_method?.method_id;
      if (step === 2 && methodChanged) {
        newId = await regeneratePurchaseId();
      }
      _state = { ..._state, purchase_id: newId, status: { action: "prepare-payment" }, payment_method: data };

      saveOnLocalStorage(name, data, productData?.product_id);
      addPreCheckoutOptionEvent(_state);
    }

    if (name === "update_status") {
      _state = { ..._state, status: data };
      // console.log("STATUS:", data);
    }

    if (name === "qty_locked") {
      _state = { ..._state, qty_locked: data };
    }

    if (name === "mbway_refused") {
      const newMBWAYRefusedCounter = (_state.mbway_refused || 0) + 1;
      _state = { ..._state, mbway_refused: newMBWAYRefusedCounter };
      if (newMBWAYRefusedCounter >= 2) {
        Modal.confirm({
          title: t("checkout.oops"),
          content: t("checkout.mbwayRefusedContent"),
          okText: t("checkout.mbwayRefusedOk"),
          cancelButtonProps: { style: { display: "none" } },
          closable: false,
          onOk() {
            // Reload page (get new purchase_id)
            window.location.reload();
          },
        });
        return;
      }
    }

    if (name === "geo") {
      const _country = countries.find((c) => c.value === data.country_code);
      const _region = _country.regions.find((r) => r.value === data.region_code);

      _state = { ..._state, geo: { country: _country, region: _region } };
      //setState(_state);
      //await loadProduct(PRODUCT_ID, OFFERS, data.country_code, data.region_code, true);
      // InitCheckout(PRODUCT_ID, true, _state);
      reloadData = true;
      // return;
    }

    if (name === "order-bump-remove-from-cart") {
      let bumps = _state.bumps || [];
      const newBumps = bumps.filter((bump) => bump.product_id !== data.product_id);
      _state = { ..._state, bumps: newBumps };
      addPreCheckoutOptionEvent(_state);
    }

    if (name === "coupon") {
      _state = {
        ..._state,
        trigger_coupon: false,
        temp_coupon: undefined,
        coupon: { coupon_code: data, isLoading: true },
      };
      delete _state.trigger_coupon; // Temporary trigger when coupon is come from URL
      delete _state.temp_coupon; // Temporary coupon when coupon is come from URL

      addPreCheckoutOptionEvent(_state);
      reloadData = true;
      //return;
    }

    if (name === "remove-coupon") {
      //console.log(" remove-coupon _COUPON", _COUPON);
      if (_COUPON !== "") {
        _COUPON = "";
        searchParams.delete("coupon");
        setSearchParams(searchParams);
      }
      _state = { ..._state, coupon: { active: false, temp_coupon: undefined, coupon_code: "", isLoading: true } };
      addPreCheckoutOptionEvent(_state);
      reloadData = true;
    }

    if (name === "order-bump-add-to-cart") {
      let bumps = _state.bumps || [];
      bumps.push(data);

      const unique_products = [...new Map(bumps.map((item) => [item["offer_id"], item])).values()];
      _state = { ..._state, bumps: unique_products };
      addPreCheckoutOptionEvent(_state);
    }

    if (name === "identification" || reloadData === true) {
      checkDuplicated({
        product_id: PRODUCT_ID,
        selected_offer_id: _state.price_option?.offer_id,
        purchase_id: _state.purchase_id,
        identification: _state.identification,
      });
    }

    if (reloadData === true) {
      InitCheckout(PRODUCT_ID, true, _state);
      return;
    }

    // Rebuild PurchaseProducts
    const purchaseProducts = createPurchaseProductsList(productData, _state);

    _state = { ..._state, purchase_products: purchaseProducts };
    setState(_state);

    if (reloadData === true) {
      InitCheckout(PRODUCT_ID, true, _state, false);
    }

    // console.log(purchaseProductsTotal(purchaseProducts), _state.payment_method.method_id);
  };

  // DEV: fills the identification form with dummy data WITHOUT advancing the wizard.
  // Uses "update-identification" (persists only) instead of "identification" (which bumps the step),
  // then remounts the form so it picks the new values up.
  const fillDummyIdentification = async (data) => {
    // DEV: invalidate cached pre-checkout flag so the updated data is re-sent
    // and the pre_checkouts record is overwritten (same purchase_id is reused).
    store("DELETE", `precheckout-${state?.purchase_id}`);
    await actionHandler("update-identification", data);
    setIdentificationKey((value) => value + 1);
  };

  const movingActionHandler = (step, _state) => {
    if (step === 1) {
      _state = { ..._state, status: { action: "select-payment" } };
    }
    if (step === 2) {
      _state = { ..._state, status: { action: "prepare-payment" } };
    }

    if (step === 2) {
      pixelEventAddPaymentInfo(_state);
    }
    return _state;
  };

  return (
    <>
      <Helmet>
        <title>{productData?.information?.name || ""} - SalesPark</title>
        {productData?.information?.image && <link id="favicon" rel="icon" type="image/png" href={productData?.information?.image} />}
      </Helmet>

      <Spin spinning={isLoading} size="large" fullScreen={true}>
        <div style={{ height: dataLoaded ? "auto" : "100vh" }}>
          {dataLoaded && errorType === "account_suspended" && <AccountSuspended productId={PRODUCT_ID} />}
          {dataLoaded && errorType === "account_closed" && <AccountClosed />}
          {dataLoaded && errorType === "error_loading_product" && <ErrorGettingProduct />}
          {dataLoaded && errorType === "product_not_found" && <ProductNotFound />}
          {dataLoaded && errorType === "product_event_is_full" && <ProductEventIsFull />}
          {dataLoaded && errorType === "product_offer_not_found" && <ProductOfferNotFound />}
          {dataLoaded && errorType === "product_unavailable" && <ProductUnavailable />}
          {dataLoaded && errorType === "order_duplicated" && <OrderDuplicated />}
          {dataLoaded && errorType === "sales_closed" && <ProductSalesClosed message={errorTypeMessage} />}
          {dataLoaded && errorType === null && (
            <div className="flex-container" style={{ height: dataLoaded ? "auto" : "100vh" }}>
              <Layout className={`flex-box ${isWidget ? "flex-box-widget" : ""}`}>
                {!isWidget && (
                  <Header style={{ padding: 0, height: "auto" }}>
                    <LanguageSelector variant="button" className="mobile-language-selector" customStyle={checkoutStyles} />
                    <Banner data={productData?.advanced} />
                  </Header>
                )}

                <Layout style={{ backgroundColor: "white" }}>
                  <SideBar customStyle={checkoutStyles} productData={productData} data={state} actionHandler={actionHandler} isMobile={true} step={step} />
                  <Content className="main-container">
                    <Row gutter={15}>
                      <Col xs={24} sm={24} md={24} lg={16}>
                        <MainContent
                          customStyle={checkoutStyles}
                          duplicatesSales={duplicatesSales}
                          step={step}
                          identificationKey={identificationKey}
                          productData={productData}
                          data={state}
                          actionHandler={actionHandler}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={8}>
                        <SideBar
                          customStyle={checkoutStyles}
                          productData={productData}
                          data={state}
                          actionHandler={actionHandler}
                          isMobile={false}
                          step={step}
                        />
                      </Col>
                    </Row>
                  </Content>
                </Layout>
              </Layout>
            </div>
          )}
        </div>
      </Spin>
      {(env === "development" || env === "beta") && (
        <>
          {/* hidden while the drawer is open: the bar sits above everything and would cover its footer */}
          {!debugConsole.visible && (
            <div className="floating-button">
              {state?.purchase_id && (
                <small>
                  <Text copyable>{state?.purchase_id}</Text>
                </small>
              )}
              <Tooltip title={t("checkout.dummyDataTooltip")} placement="topRight">
                <UserSwitchOutlined
                  className="clickable"
                  onClick={async () => {
                    const data = dummyData();
                    await fillDummyIdentification(data);

                    notification.success({
                      message: t("checkout.dummyDataSuccess"),
                      description: t("checkout.dummyDataDescription", { name: data.name, email: data.email, phone: data.phone }),
                    });
                  }}
                />
              </Tooltip>
              <Tooltip title={t("checkout.debugConsoleTooltip")} placement="topRight">
                <CodeOutlined className="clickable" onClick={() => setDebugConsole({ visible: true, data: state })} />
              </Tooltip>
            </div>
          )}
          <DebugConsoleDrawer
            debugConsole={debugConsole}
            setDebugConsole={setDebugConsole}
            updateIdentification={fillDummyIdentification}
          />
        </>
      )}
    </>
  );
};

export default IndexPage;
